import { render, staticRenderFns } from "./BannerCardValues.vue?vue&type=template&id=4e930f3e&scoped=true"
import script from "./BannerCardValues.vue?vue&type=script&lang=js"
export * from "./BannerCardValues.vue?vue&type=script&lang=js"
import style0 from "./BannerCardValues.vue?vue&type=style&index=0&id=4e930f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e930f3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardValues: require('/home/luiz/Sistemas/loja/components/CardValues.vue').default,ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default,SheletonLoaders: require('/home/luiz/Sistemas/loja/components/SheletonLoaders.vue').default})
